import React from 'react';
import { I } from '../common/v5/config';
import { saveError } from '../lib/api';

const fallbackStyle = {
		alignItems: 'center'
		, color: '#6c757d'
		, display: 'flex'
		, flexDirection: 'column'
		, fontSize: '13px'
		, height: '100%'
		, justifyContent: 'center'
		, minHeight: '80px'
		, padding: '10px'
		, textAlign: 'center'
		, width: '100%'
	}
	, retryStyle = {
		color: '#0c87f7'
		, cursor: 'pointer'
		, marginTop: '5px'
	}
	;

// Error boundary meant to wrap a single widget (eg one chart on the
// statistics page) so that a render error - typically caused by
// unexpected data from the backend - only takes down that widget
// instead of bubbling up to the app level error page. The error is
// still reported to the backend jserror endpoint for visibility.
class WidgetErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
		this.handleRetry = this.handleRetry.bind(this);
	}
	static getDerivedStateFromError() {
		return { hasError: true };
	}
	componentDidCatch(error, errorInfo) {
		console.error('widget render error:', error, errorInfo);
		try {
			saveError({
				error: { message: error && error.toString() }
				, errorInfo
			}).catch(() => {});
		} catch (e) {
			// reporting must never throw
		}
	}
	handleRetry() {
		this.setState({ hasError: false });
	}
	render() {
		if (this.state.hasError) {
			return (
				<div style={fallbackStyle} data-qa-id="widget-error-fallback">
					<i className="icon-exclamation-triangle" />
					<span>{I("This content could not be displayed.")}</span>
					<span style={retryStyle} onClick={this.handleRetry}>
						{I("Try again")}
					</span>
				</div>
			);
		}
		return this.props.children;
	}
}

export const withWidgetErrorBoundary = Component => {
	const Wrapped = props => (
		<WidgetErrorBoundary>
			<Component {...props} />
		</WidgetErrorBoundary>
	);
	Wrapped.displayName = 'withWidgetErrorBoundary(' +
		(Component.displayName || Component.name || 'Component') + ')';
	return Wrapped;
};

export default WidgetErrorBoundary;
